import * as HeadingLayout from './heading-layout';

/**
 * Gene Coverage Browser 상단 hero (제목/부제).
 *
 * searchParams 에 의존하지 않는 정적 영역이라 서버에서 렌더 가능하다.
 * page.tsx 의 Suspense fallback 으로도 쓰여, 하이드레이션 전 정적 HTML(SSG)에
 * 미리 그려지므로 진입 시 흰 화면 대신 hero 가 먼저 보인다.
 *
 * children 으로 검색창 등 인터랙티브 영역을 hero 안에 끼워 넣는다.
 */
function GeneCoverageHero({ children }: { children?: React.ReactNode }) {
  return (
    <HeadingLayout.Background>
      <HeadingLayout.Layout>
        <HeadingLayout.MainTitle>Gene Coverage Browser</HeadingLayout.MainTitle>
        <HeadingLayout.SubTitle>
          Look up 3B-EXOME and 3B-GENOME coverage for your gene(s) of interest.
        </HeadingLayout.SubTitle>
        {children}
      </HeadingLayout.Layout>
    </HeadingLayout.Background>
  );
}

export default GeneCoverageHero;
